import styles from './style.module.scss';
import { useInView, motion } from 'framer-motion';
import { useRef } from 'react';
import { slideUp } from './anim';
import React from 'react';
import styled from 'styled-components';
import { AnimatedTextProps, AnimTextProp } from '../../common/types';

const AnimText = styled.div<AnimTextProp>`
    margin: ${({$margin}) => $margin || 0}
`;

const AnimatedText: React.FC<AnimatedTextProps> = ({ text, className = '', $animTextMargin }) => {
    const containerRef = useRef(null);
    const isInView = useInView(containerRef, { once: false});
   
    return (
        <AnimText $margin={$animTextMargin} ref={containerRef} className={`${styles.description} `}>
            <div className={styles.body}>
                {
                    text.split("<br />").map((line, lineIndex) => (
                        <p key={lineIndex} className={className}>
                            {
                                line.split(" ").map((word, wordIndex) => (
                                    <span className={styles.mask} key={wordIndex}>
                                        <motion.span
                                            variants={slideUp}
                                            custom={wordIndex}
                                            animate={isInView ? "open" : "closed"}
                                            initial="initial"
                                        >
                                            {word}
                                        </motion.span>
                                    </span>
                                ))
                            }
                        </p>
                    ))
                }
            </div>
        </AnimText>
    );
};

export default React.memo(AnimatedText);
